/* eslint-disable */

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Input, Button, Checkbox, Typography, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import './Login.css';

const { Title, Text } = Typography;

function Login(props) {
  const [loading, setLoading] = useState(false);

  const saveToken = (userToken) => {
    sessionStorage.setItem('meya-management', JSON.stringify(userToken));
  };

  useEffect(() => {
    saveToken({
      username: '',
      role: '',
      token: '',
      logintime: '',
      uid: '',
    });
  }, []);

  function callback_signin(data) {
    props.callback_signin(data);
  }

  const onFinish = (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append('username', values.username);
    formData.append('password', values.password);

    axios
      .post(props.app_hostname + '/api/account/auth/office_signin', formData, {
        headers: {
          Accept: 'application/json',
        },
      })
      .then((response) => {
        setLoading(false);
        if (response.data.status === 'OK') {
          saveToken(response.data.userinfo);
          message.success('เข้าสู่ระบบสำเร็จ');
          callback_signin(response.data.userinfo);
        } else if (response.data.status === 'login-fail') {
          saveToken({
            username: '',
            role: '',
            token: '',
            logintime: '',
            uid: '',
          });
          message.error(response.data.message || 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง');
        } else {
          message.error(response.data.message || 'เกิดข้อผิดพลาดในการเข้าสู่ระบบ');
        }
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  };

  return (
    <div className='login-container'>
      <div className='login-card'>
        <div className='login-header'>
          <img src={'/images/Meya-logo1.png'} alt='Logo' className='login-logo' />
          <Title level={3} className='login-title'>
            Meya Management Platform
          </Title>
          <Text type='secondary' className='login-subtitle'>
            กรุณาเข้าสู่ระบบเพื่อใช้งาน
          </Text>
        </div>

        <Form
          name='login_form'
          className='login-form'
          initialValues={{ remember: true }}
          onFinish={onFinish}
          size='large'
          layout='vertical'
        >
          <Form.Item
            name='username'
            label='ชื่อผู้ใช้'
            rules={[{ required: true, message: 'กรุณากรอกชื่อผู้ใช้งาน!' }]}
          >
            <Input
              prefix={<UserOutlined className='site-form-item-icon' />}
              placeholder='Username'
            />
          </Form.Item>

          <Form.Item
            name='password'
            label='รหัสผ่าน'
            rules={[{ required: true, message: 'กรุณากรอกรหัสผ่าน!' }]}
          >
            <Input.Password
              prefix={<LockOutlined className='site-form-item-icon' />}
              placeholder='Password'
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: '20px' }}>
            <Form.Item name='remember' valuePropName='checked' noStyle>
              <Checkbox>จดจำฉันในระบบ</Checkbox>
            </Form.Item>
          </Form.Item>

          <Form.Item style={{ marginBottom: '12px' }}>
            <Button
              type='primary'
              htmlType='submit'
              className='login-form-button'
              block
              loading={loading}
            >
              Sign In
            </Button>
          </Form.Item>
        </Form>

        <div className='login-footer'>
          <Text type='secondary' style={{ fontSize: '12px' }}>
            Version 1.0.3
          </Text>
        </div>
      </div>
    </div>
  );
}

export default Login;
